var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAwesomeUserGraduate = function SvgIconAwesomeUserGraduate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.61,
    height: 44.128,
    viewBox: "0 0 38.61 44.128",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-graduate",
    "data-name": "Icon awesome-user-graduate",
    d: "M27.527,27.631l-8.222,8.222-8.222-8.222A11.557,11.557,0,0,0,0,39.162v.827a4.138,4.138,0,0,0,4.137,4.137H34.473A4.138,4.138,0,0,0,38.61,39.99v-.827A11.557,11.557,0,0,0,27.527,27.631ZM1.172,6.878l.552.129V12.04a1.991,1.991,0,0,0-.078,3.447L.3,20.857c-.147.595.181,1.207.655,1.207h3.6c.474,0,.8-.612.655-1.207L3.87,15.488a1.991,1.991,0,0,0-.078-3.447V7.507L9.48,8.877A11.012,11.012,0,1,0,30.337,13.79,10.835,10.835,0,0,0,29.13,8.877l8.3-2a1.371,1.371,0,0,0,0-2.715L21.02.2A7.4,7.4,0,0,0,17.6.2L1.172,4.154a1.377,1.377,0,0,0,0,2.723Z",
    transform: "translate(0 0.002)",
    fill: "#b0b0b0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeUserGraduate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-awesome-user-graduate.c38608ec53e93902b9fc948656e2d37d.svg";